export enum DurationType {
  from_login = 'from_login',
  from_purchase = 'from_purchase',
}

export interface ITicketingToursByYourself {
  id: number;
  tourId: number;

  //base
  name: string;
  description: string;
  ticketPrice: number;
  durationType: DurationType;
  duration: number;
  limitDevices: number;
  accessTours: string[];
  selectedSweeps: any;
  ticketInfoUlr: string;
}

export interface ITicketingGuidedTour {
  id: number;
  tourId: number;
  timeSlotId: number;

  //base
  name: string;
  description: string;
  ticketPrice: number;
  maxParticipants: number;
  duration: number;
  tourLanguage: string;
  ticketInfoUlr: string;
}

export interface ITicketingGameTour {
  id: number;
  tourId: number;

  //base
  name: string;
  description: string;
  ticketPrice: number;
  ticketInfoUlr: string;
  durationType: DurationType;
  duration: number;
  limitDevices: number;
}
